import PNLReportPresenter from "@adapters/presenters/Reports/PNLReport";
import PNLTransactionReportPresenter from "@adapters/presenters/Reports/PNLTransactionReport";
import { GTMService, worker } from "@di";
import { PNLDashBoardActions } from "./actions";
import abortControllerClass from "@domains/utils/abortControllerClass";
export default (useCases, actions, understandUseCase) => {
    return {
        pnlReport: new PNLReportPresenter(useCases.pnlReport, useCases.commonPNL, useCases.downloadPDFReports, useCases.downloadExcelReports, useCases.sendEmailReports, actions, understandUseCase.understandingSection, GTMService, useCases.quoteStream, useCases.dashboardSummaryUseCase, PNLDashBoardActions, worker, new abortControllerClass(new AbortController())),
        pnlTransactionReport: new PNLTransactionReportPresenter(useCases.pnlTransactionReport, useCases.pnlEditTransactionReport, actions, understandUseCase.understandingSection, useCases.holdingTxnUseCase, useCases.originalTxns),
    };
};
